(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bwww-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bwww-hero-carousel')) {
  customElements.define('bwww-hero-carousel', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.slides = Array.from(this.querySelectorAll('.bwww-carousel-slide'));
      this.viewport = this.querySelector('.bwww-carousel-viewport');
      this.controls = this.querySelector('.bwww-carousel-controls');
      this.rotation = this.querySelector('[data-rotation]');
      this.counter = this.querySelector('[data-count]');
      this.forcePlay = false;
      this.pointerFocus = false;
      this.touch = null;
      this.index = 0;
      this.token = 0;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.enabled = !this.motion.matches;
      this.visible = false;
      this.hovered = false;
      this.focused = this.contains(document.activeElement);
      this.interval = Math.max(2000, Number(this.dataset.interval) || 2000);
      this.slides.forEach((slide, index) => { slide.hidden = index !== 0; });
      if (this.slides.length < 2) return;
      this.controls.hidden = false;
      this.rotation.addEventListener('click', () => {
        this.enabled = !this.enabled;
        this.forcePlay = this.enabled;
        this.sync();
      }, { signal });
      this.querySelector('[data-previous]').addEventListener('click', () => this.manual(-1), { signal });
      this.querySelector('[data-next]').addEventListener('click', () => this.manual(1), { signal });
      this.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse') { this.hovered = true; this.forcePlay = false; this.schedule(); }
      }, { signal });
      this.addEventListener('pointerleave', event => {
        if (event.pointerType === 'mouse') { this.hovered = false; this.schedule(); }
      }, { signal });
      document.addEventListener('keydown', () => {
        this.pointerFocus = false;
        this.focused = this.contains(document.activeElement);
        this.forcePlay = false;
        this.schedule();
      }, { signal });
      this.addEventListener('focusin', () => {
        this.focused = !this.pointerFocus;
        this.forcePlay = false;
        this.schedule();
      }, { signal });
      this.addEventListener('focusout', event => {
        this.focused = this.focused && this.contains(event.relatedTarget);
        this.schedule();
      }, { signal });
      this.addEventListener('pointerdown', event => {
        this.suppressClickUntil = 0;
        this.pointerFocus = true;
        this.focused = false;
        this.forcePlay = false;
        if (event.pointerType !== 'touch' || !event.isPrimary) { this.schedule(); return; }
        this.touch = { x: event.clientX, y: event.clientY, id: event.pointerId, started: Date.now() };
        clearTimeout(this.timer);
      }, { signal });
      document.addEventListener('pointerup', event => {
        if (!this.touch || this.touch.id !== event.pointerId) return;
        const dx = event.clientX - this.touch.x;
        const dy = event.clientY - this.touch.y;
        const held = Date.now() - this.touch.started >= 250;
        this.touch = null;
        if (held || Math.abs(dx) > 12 || Math.abs(dy) > 12) this.suppressClickUntil = Date.now() + 500;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          this.manual(dx < 0 ? 1 : -1);
        } else this.schedule();
      }, { signal });
      document.addEventListener('pointercancel', event => {
        if (this.touch?.id !== event.pointerId) return;
        this.touch = null;
        this.suppressClickUntil = Date.now() + 500;
        this.schedule();
      }, { signal });
      this.addEventListener('click', event => {
        if (Date.now() < (this.suppressClickUntil || 0)) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, { capture: true, signal });
      this.viewport.addEventListener('contextmenu', event => event.preventDefault(), { signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.touch = null;
        this.schedule();
      }, { signal });
      window.addEventListener('blur', () => {
        this.touch = null;
        this.schedule();
      }, { signal });
      window.addEventListener('focus', () => this.schedule(), { signal });
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.enabled = false;
        this.sync();
      }, { signal });
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.schedule();
      }, { threshold: 0.2 });
      this.observer.observe(this);
      this.preloadNext();
      this.sync();
    }

    disconnectedCallback() {
      this.token += 1;
      clearTimeout(this.timer);
      this.abort?.abort();
      this.observer?.disconnect();
    }

    manual(direction) {
      this.show(this.index + direction);
    }

    sync() {
      this.rotation.textContent = this.enabled ? this.dataset.pauseLabel : this.dataset.playLabel;
      this.viewport.setAttribute('aria-live', this.enabled ? 'off' : 'polite');
      this.counter.setAttribute('aria-live', this.enabled ? 'off' : 'polite');
      this.schedule();
    }

    schedule() {
      clearTimeout(this.timer);
      if (this.canRotate()) {
        this.timer = setTimeout(() => this.show(this.index + 1, true), this.interval);
      }
    }

    canRotate() {
      return this.enabled && this.visible && (this.forcePlay || (!this.hovered && !this.focused)) && !this.touch && !document.hidden;
    }

    preloadNext() {
      const image = this.slides[(this.index + 1) % this.slides.length]?.querySelector('img');
      if (image) image.loading = 'eager';
    }

    async show(position, automatic = false) {
      clearTimeout(this.timer);
      const index = (position + this.slides.length) % this.slides.length;
      const request = ++this.token;
      const image = this.slides[index].querySelector('img');
      if (image) {
        image.loading = 'eager';
        try { await image.decode(); } catch {}
      }
      if (!this.isConnected || request !== this.token) return;
      if (automatic && !this.canRotate()) { this.schedule(); return; }
      this.slides.forEach((slide, slideIndex) => { slide.hidden = slideIndex !== index; });
      this.index = index;
      this.counter.textContent = this.dataset.countLabel.replace('[current]', String(index + 1));
      if (!this.motion.matches) {
        this.slides[index].animate([{ opacity: 0.25 }, { opacity: 1 }], { duration: 350, easing: 'ease-out' });
      }
      this.preloadNext();
      this.schedule();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
